import * as React from "react";
const SvgCaretDown24X24 = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", "data-name": "Layer 1", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.41 9.21h7.18a1 1 0 0 1 .7 1.7l-3.58 3.59a1 1 0 0 1-1.42 0l-3.58-3.59a1 1 0 0 1 .7-1.7", style: {
  fill: "#010101"
} }));
export default SvgCaretDown24X24;
